var atob: any =
  typeof atob !== 'undefined'
    ? atob
    : (base64: string) => {
        return Buffer.from(base64, 'base64').toString()
      }

export function parseJwt(token: string): any {
  var base64Url = token.split('.')[1]
  var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
  var jsonPayload = decodeURIComponent(
    atob(base64)
      .split('')
      .map(function (c: string) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
      })
      .join('')
  )

  return JSON.parse(jsonPayload)
}
